import { useParams } from "react-router-dom"
import { CloudUpload } from "@mui/icons-material"
import { useAppSelector } from "hooks/redux"
import useCancelUploadPrompt from "hooks/upload-cancel-prompt"
import HomeHeader from "modules/home-header"
import { Creators } from "./model"
import { getCurrentSwap } from "./selectors"

interface Props {
  account: string
}

export default function SwapPositionsHeader({ account }: Props) {
  const params = useParams()
  const swap = useAppSelector(state => getCurrentSwap(state, { params }))
  const promptCancel = useCancelUploadPrompt(`/${account}/home/resources`, Creators.resetUpload)

  return <HomeHeader
    account={account}
    Icon={CloudUpload}
    title={swap ? `Upload positions for ${swap.ticker}` : "Upload"}
    onLogoClick={promptCancel}
  />
}
